"use client";
import React, { useEffect, useState } from "react";
import CommonImage from "@/components/common/image/CommonImage";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination, Autoplay } from "swiper/modules";
import HomePageService from "@/services/api/HomeService";
import Link from "next/link";
import UniversityCard from "@/components/common/card/UniversityCard";

// const universities = [
//   {
//     id: 1,
//     name: "জাহাঙ্গীরনগর বিশ্ববিদ্যালয়",
//     img: "/images/admission-icon/universitys-icon.png",
//   },
//   {
//     id: 2,
//     name: "শাহজালাল বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়",
//     img: "/images/home/jahingirnagar-university.png",
//   },
//   {
//     id: 3,
//     name: "ঢাকা মেডিকেল কলেজ",
//     img: "/images/home/dhaka-university.png",
//   },
//   {
//     id: 4,
//     name: "জাহাঙ্গীরনগর বিশ্ববিদ্যালয়",
//     img: "/images/admission-icon/universitys-icon.png",
//   },
//   {
//     id: 5,
//     name: "শাহজালাল বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়",
//     img: "/images/home/jahingirnagar-university.png",
//   },
//   {
//     id: 6,
//     name: "ঢাকা মেডিকেল কলেজ",
//     img: "/images/home/dhaka-university.png",
//   },
//   {
//     id: 7,
//     name: "জাহাঙ্গীরনগর বিশ্ববিদ্যালয়",
//     img: "/images/admission-icon/universitys-icon.png",
//   },
//   {
//     id: 8,
//     name: "শাহজালাল বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়",
//     img: "/images/home/jahingirnagar-university.png",
//   },
//   {
//     id: 9,
//     name: "ঢাকা মেডিকেল কলেজ",
//     img: "/images/home/dhaka-university.png",
//   },
// ];

export default function UniversitiesSection() {
  const [loading, setLoading] = useState(false);
  const [universities, setUniversities] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  const fetchUniversities = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const response = await HomePageService.getUniversities(pageNumber);
      console.log("response", response);
      if (response?.data?.length > 0) {
        setUniversities((prev) => [...prev, ...response?.data]);
        setPage(pageNumber);
        if (response.length < 10) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching universities:", error);
    } finally {
      setLoading(false);
      setInitialLoadDone(true);
    }
  };

  useEffect(() => {
    fetchUniversities(1);
  }, []);

  return (
    <section className="universities_Section section_padding">
      <div className="section_title-center">
        <h2 className="title flex items-center gap-2">
          <span className="w-8 h-8">
            <CommonImage
              src="/images/admission-icon/universitys-icon.png"
              className="img-icon"
              alt="Book Icon"
            />
          </span>
          বিশ্ববিদ্যালয় সমূহ
        </h2>
        <p className="short-des">
          ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
          গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে
          আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
        </p>
      </div>

      <div className="section-content-wrap">
        <Swiper
          slidesPerView="auto"
          freeMode={true}
          speed={1000}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[FreeMode, Pagination, Autoplay]}
          breakpoints={{
            0: { spaceBetween: 10 },
            576: { spaceBetween: 15 },
            992: { spaceBetween: 24 },
          }}
          className="universities-slider"
          onReachEnd={() => {
            if (!loading && hasMore && initialLoadDone) {
              fetchUniversities(page + 1);
            }
          }}
        >
          {universities?.map((uni, index) => (
            <SwiperSlide key={index} className="!w-auto">
             <UniversityCard uni={uni}/>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
